import { useLanguage } from "@/hooks/useLanguage";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-muted/50 rounded-full p-1">
      <Button
        variant="ghost"
        size="sm"
        className={`h-7 px-3 rounded-full text-xs font-medium transition-all ${
          language === 'en'
            ? 'bg-background text-foreground shadow-sm hover:bg-accent hover:text-white'
            : 'text-muted-foreground hover:bg-accent hover:text-white'
        }`}
        onClick={() => setLanguage('en')}
      >
        EN
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={`h-7 px-3 rounded-full text-xs font-medium transition-all ${
          language === 'fr'
            ? 'bg-background text-foreground shadow-sm hover:bg-accent hover:text-white'
            : 'text-muted-foreground hover:bg-accent hover:text-white'
        }`}
        onClick={() => setLanguage('fr')}
      >
        FR
      </Button>
    </div>
  );
}
